document.addEventListener('DOMContentLoaded', () => {
    if (!window.Chart?.defaults?.global) {
        return;
    }

    const labelColor = getComputedStyle(document.documentElement)
        .getPropertyValue('--calcimo-chart-label').trim();

    window.Chart.defaults.global.defaultFontColor = labelColor;
});
